
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCoastalNavigationFill as ObiCoastalNavigationFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-coastal-navigation-fill.js';
 
 
 

 
 export const ObiCoastalNavigationFill = createComponent({
   react: React,
   tagName: 'obi-coastal-navigation-fill',
   elementClass: ObiCoastalNavigationFillElement,
   events: {
     
   }
  });
 
 